import classNames from 'classnames';
import { PropsWithClassName, PropsWithChildren } from 'shared/props';
import styles from './content-panel-interaction.module.scss';

export interface ContentPanelInteractionProps extends PropsWithClassName {

}
export const ContentPanelInteraction = (props: ContentPanelInteractionProps & PropsWithClassName & PropsWithChildren) => {
	return (
		<div className={classNames(styles.container, props.className)}>
			{ props.children }
		</div>
	);
}
